export default function useConfig() {
  function memoizeDynamicConfig(config, mode, env, rootConfig = config) {
    for (let key in config) {
      if (config[key] instanceof Object && typeof config[key] !== 'function') {
        memoizeDynamicConfig(config[key], mode, env, rootConfig)
      }
      else if (typeof config[key] === 'function') {
        let originalMethod = config[key]
        let memoized = false
        let computedValue = null

        // Replace the original config function with a new function that when first called, memoizes the return value
        config[key] = () => {
          if (memoized) return computedValue
          else {
            memoized = true
            computedValue = originalMethod(rootConfig, { mode: mode, env: env })
            return computedValue
          }
        }
      }
    }
  }

  function mergeWithDefaults(defaults, config) {
    const result = { ...defaults }

    for (let key in config) {
      if (config[key] instanceof Object && defaults[key] instanceof Object) {
        result[key] = mergeWithDefaults(defaults[key], config[key])
      } else {
        result[key] = config[key]
      }
    }

    return result
  }

  function nodeMode() {
    const modeFlagIndex = process.argv.indexOf('--mode')
    if (modeFlagIndex > -1) return process.argv[modeFlagIndex + 1]
    else {
      if (Object.hasOwn(process, 'env') && Object.hasOwn(process.env, 'NODE_ENV')) return process.env.NODE_ENV
      else return 'development'
    }
  }

  return {
    memoizeDynamicConfig,
    mergeWithDefaults,
    nodeMode
  }
}